import { TimeUnits } from '../../shared/data-types/unit-types';

export const TimeUnitOptionLiterals = new Map<TimeUnits, string>([
  [TimeUnits.Day, 'Tag'],
  [TimeUnits.Week, 'Woche'],
  [TimeUnits.Month, 'Monat'],
  [TimeUnits.Year, 'Jahr'],
]);
